export default __webpack_public_path__ + "static/media/1106.2c6ff573.png";